import { AlarmProfiles } from "../alarms/entities/alarm-profiles";
import { DependencyInjectionContainer } from "./dependency-injection-container";

const alarmProfilesKey = "alarmProfiles";
const alarmProfilesCopyKey = "alarmProfilesCopy";

export const getAlarmProfiles = () => {
  return DependencyInjectionContainer.getInstance().resolve<AlarmProfiles>(
    alarmProfilesKey,
  );
};

export const registerAlarmProfiles = () => {
  DependencyInjectionContainer.getInstance().register(
    alarmProfilesKey,
    AlarmProfiles,
  );
};

export const getAlarmProfilesReferenceCopy = () => {
  return DependencyInjectionContainer.getInstance().resolve<AlarmProfiles>(
    alarmProfilesCopyKey,
  );
};

export const registerAlarmProfilesReferenceCopy = () => {
  DependencyInjectionContainer.getInstance().register(
    alarmProfilesCopyKey,
    AlarmProfiles,
  );
};
